(function() {
  // --- CONFIGURACIÓN ---
  const targetClasses = [
    'is--blockidmarca',
    'is--blockidingredientes',
    'is--blockid_price',
    'is--blockidsabor',
    'is--blockidtema-de-interes',
    'is--blockidporciones',
    'is--blockidpreferencias',
    'is--blockidcomposicion',
    'is--blockidobjetivo',
    'is--blockidpara-quien'
  ];
  // --------------------

  // <-- CAMBIO: Objeto para guardar el estado (abierto/cerrado) de cada sección.
  const collapsibleState = {};

  /**
   * Esta función toma un elemento de bloque y lo hace colapsable,
   * respetando su estado anterior si existe.
   * @param {HTMLElement} blockElement - El elemento contenedor.
   * @param {string} uniqueId - El identificador único del bloque (usaremos la clase).
   */
  function inicializarCollapsible(blockElement, uniqueId) { // <-- CAMBIO: Añadimos uniqueId
    // La solución para el doble clic ya está aquí y es correcta.
    if (blockElement.dataset.collapsibleInitialized) {
      return;
    }
    blockElement.dataset.collapsibleInitialized = 'true';

    const title = blockElement.querySelector('.t4s-facet-title');
    const content = blockElement.querySelector('.t4s-facet-content');

    if (!title || !content) {
      return;
    }

    // Aplicar estilos y funcionalidad
    title.style.cursor = 'pointer';
    title.style.userSelect = 'none';
    title.style.position = 'relative';
    title.style.paddingRight = '25px';

    content.style.overflow = 'hidden';
    content.style.transition = 'max-height 0.4s ease-in-out';

    const icon = document.createElement('span');
    icon.style.cssText = "position:absolute; right:10px; top:50%; transform:translateY(-50%); font-size:20px; font-weight:bold;";
    title.appendChild(icon);

    // ---- INICIO DE LOS AJUSTES DE ESTADO ----

    // <-- CAMBIO: Decidimos si debe empezar colapsado o no.
    // Por defecto, empieza colapsado, a menos que su estado guardado sea 'open'.
    const shouldStartOpen = collapsibleState[uniqueId] === 'open';

    if (shouldStartOpen) {
      // Si debe empezar abierto
      blockElement.classList.remove('is-collapsed');
      // Es importante calcular la altura real del contenido para mostrarlo.
      // Usamos un pequeño truco para que el navegador lo calcule correctamente.
      setTimeout(() => {
        content.style.maxHeight = content.scrollHeight + 'px';
      }, 0);
      icon.textContent = '−';
    } else {
      // Si debe empezar cerrado (comportamiento original)
      blockElement.classList.add('is-collapsed');
      content.style.maxHeight = '0px';
      icon.textContent = '+';
    }
    
    // ---- FIN DE LOS AJUSTES DE ESTADO ----

    title.addEventListener('click', function() {
      const isNowCollapsed = blockElement.classList.toggle('is-collapsed');
      
      if (isNowCollapsed) {
        // Se acaba de colapsar
        content.style.maxHeight = '0px';
        icon.textContent = '+';
        collapsibleState[uniqueId] = 'closed'; // <-- CAMBIO: Guardamos el estado
      } else {
        // Se acaba de expandir
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.textContent = '−';
        collapsibleState[uniqueId] = 'open'; // <-- CAMBIO: Guardamos el estado

        // --- NUEVO: colapsar los demás bloques ---
        Object.keys(collapsibleState).forEach(id => {
          if (id !== uniqueId && collapsibleState[id] === 'open') {
            const otherBlock = document.querySelector(`.${id}`);
            if (otherBlock) {
              const otherContent = otherBlock.querySelector('.t4s-facet-content');
              const otherIcon = otherBlock.querySelector('.t4s-facet-title span:last-child');
              otherBlock.classList.add('is-collapsed');
              if (otherContent) otherContent.style.maxHeight = '0px';
              if (otherIcon) otherIcon.textContent = '+';
              collapsibleState[id] = 'closed';
            }
          }
        });
        // --- FIN NUEVO ---
        
      }
    });
  }

  /**
   * Busca en la página todos los elementos que coincidan con las clases objetivo
   * y los inicializa.
   */
  function buscarYActivarCollapsibles() {
    targetClasses.forEach(className => {
      const elements = document.querySelectorAll(`.${className}`);
      // <-- CAMBIO: Pasamos la clase como identificador único
      elements.forEach(el => inicializarCollapsible(el, className)); 
    });
  }

  // --- Lógica del Observador (sin cambios) ---
  const targetNode = document.body;
  const config = { childList: true, subtree: true };

  const callback = function(mutationsList, observer) {
    buscarYActivarCollapsibles();
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

  // Ejecutar una vez al inicio
  buscarYActivarCollapsibles();

})();
